import { useState } from 'react';
import { TOPIC_OPTIONS } from '../constants/hixrs';
import { getCustomTopicOptions, getPostTypeOption, getTopicLabel, getTopicStyle, isOpenThought, postMatchesTopic } from '../utils/hixrs';
import { getTotalComments } from '../utils/threads';
import { EmptyState, SkeletonList } from '../components/common';

export function SearchScreen({ posts, users = [], onOpen, onTopicSelect, postsLoading, onProfileOpen }) {
  const [query, setQuery] = useState('');
  const normalized = query.trim().toLowerCase();
  const postResults = normalized
    ? posts.filter(p => [p.question, p.topic, p.sideA, p.sideB, p.authorName, getPostTypeOption(p.postType).label]
        .some(value => value?.toLowerCase().includes(normalized)))
    : [];
  const peopleResults = normalized
    ? users
        .filter(user => [user.displayName, user.username, user.email]
          .some(value => value?.toLowerCase().includes(normalized)))
        .slice(0, 8)
    : [];
  const topics = [
    { name: 'Trending', key: 'trending' },
    ...TOPIC_OPTIONS.map(topic => ({ name: topic.label, key: topic.key })),
    ...getCustomTopicOptions(posts).map(topic => ({ name: topic.label, key: topic.key }))
  ].map(topic => ({
    ...topic,
    count: topic.key === 'trending'
      ? posts.filter(p => (p.heat || 0) >= 70).length || posts.length
      : posts.filter(p => postMatchesTopic(p, topic.key)).length
  }));

  return (
    <div className="screen-wrap">
      <div className="search-wrap">
        <div className="search-header">
          <div className="create-kicker">Explore</div>
          <div className="screen-title">Find Hixs and topics</div>
          <div className="screen-sub">Search by question, side, creator, or topic.</div>
        </div>
        <input className="search-big" placeholder="Search Hixs..."
          value={query} onChange={e => setQuery(e.target.value)} autoFocus />
        {postsLoading ? (
          <SkeletonList count={4} />
        ) : query.trim() ? (
          postResults.length === 0 && peopleResults.length === 0
            ? <EmptyState
                eyebrow="Search"
                title="Nothing found"
                body={`Nothing matched "${query}". Try a creator name, topic, or a shorter phrase.`}
                actionLabel="Clear search"
                onAction={() => setQuery('')} />
            : <div className="search-results-list">
                {peopleResults.length > 0 && (
                  <div className="search-section">
                    <div className="browse-label">People</div>
                    {peopleResults.map(person => {
                      const name = person.displayName || 'Hixrs user';
                      const handle = person.username ? `@${person.username}` : person.email || 'Profile';
                      const initial = name?.[0]?.toUpperCase() || 'H';
                      return (
                        <button key={person.uid || person.id || person.email} type="button" className="person-result" onClick={() => onProfileOpen?.(person)}>
                          <div className="person-result-avatar">
                            {person.photoURL ? <img src={person.photoURL} alt={name} /> : initial}
                          </div>
                          <div className="person-result-copy">
                            <strong>{name}</strong>
                            <span>{handle}</span>
                          </div>
                        </button>
                      );
                    })}
                  </div>
                )}
                {postResults.length > 0 && (
                  <div className="search-section">
                    <div className="browse-label">Hixs</div>
                    {postResults.map(p => (
                      <div key={p.id} className={`search-result hix-theme-${getPostTypeOption(p.postType).key}`} onClick={() => onOpen(p)}>
                        <div className="sr-question">{p.question}</div>
                        <div className="sr-meta">
                          <span className="post-topic" style={getTopicStyle(p.topic)}>{getTopicLabel(p.topic)}</span>
                          <span className={`post-type-badge type-${getPostTypeOption(p.postType).key}`}>{getPostTypeOption(p.postType).label}</span>
                          <span>{isOpenThought(p) ? `${getTotalComments(p.comments || [])} comments` : `${p.totalVotes || 0} lock-ins`}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
        ) : (
          <>
            <div className="browse-label">Browse Topics</div>
            <div className="topic-grid">
              {topics.map(t => (
                <button key={t.name} className="topic-card" onClick={() => onTopicSelect(t.key)}>
                  <div className="tc-name">{t.name}</div>
                  <div className="tc-count">{t.key === 'trending' ? 'Hot' : t.count} {t.key === 'trending' ? '' : 'posts'}</div>
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
